const user = {
  newUser: "Nuevo Usuario",
  firstName: "Nombre",
  lastName: "Apellido",
  email: "Correo Electronico",
  role: "Rol",
  company: "Compañia",
  userLevel: "Nivel de Acceso",
  password: "Contraseña",
  confirm: "Confirmar Contraseña",
  btn: "Crear nuevo usuario",
  save: "Guardar Cambios",
  metric: "Sistema De Unidades",
  imperial: "Imperial",
  language: "Idioma",
  date: "Fecha de Registro",
  userProfile: "Perfil de Usuario",
  userList: "Lista de Usuario",
  search: "Buscar",
  disable: "Desactivada",
  actions: "Acciones",
  reset: "Recuperar Contraseña",
  status: "Estatus",
  plant: "Edificio",
  submit: "Enviar",
  theme: {
    title: "Tema del App",
    dark: "Ocuro",
    light: "Claro"
  },
  metaxuser: "¿Usuario Metax?",
  boolean: {
    yes: "Si",
    no: "No"
  },
  roles: {
    super: "Super Admin",
    engineer: "Ingeniero",
    admin: "Admin",
    supervisor: "Supervisor",
    reliability: "Confiablidad",
    operator: "Operador"
  },
  messages: {
    default: "Este campo es requerido",
    email: {
      required: "Correo electrónico requirido",
      valid: "Correo electrónico inválido"
    },
    password: {
      required: "Contraseña requerida",
      valid: "La contraseña debe ser 6 characteres como mínimo",
      hint: "6 characteres como mínimo",
      retype: "Contraseña no coincide"
    },
    snackbar: {
      successful: "Usuario creado satisfactoriamente",
      error: "No fue posible crear usuario"
    }
  },
  backbtn: "Atrás",
  modulesbtn: "Módulos",
  closebtn: "Cerrar"
};
export default user;
